/*
 * @Author: gaobin
 * @Date: 2025-03-18 19:47:08
 * @LastEditors:
 * @LastEditTime: 2025-03-19 13:54:44
 * @Description: 请填写简介
 */
const addressMap = {
  // 获取用户地址列表 get
  getUserAddressList: '/usb/uwb-app/api/v1/userAddress/list',

  // 新增地址
  addAddress: '/usb/uwb-app/api/v1/userAddress/add',

  // 更新地址
  editAddress: '/usb/uwb-app/api/v1/userAddress/update',

  // 删除地址
  delAddress: '/usb/uwb-app/api/v1/userAddress/delete',

  // 按上级查询地址
  getByParendId: '/usb/area/listByParam',

  // 修改默认地址
  updateDefaultAddress: '/usb/uwb-app/api/v1/userAddress/updateDefaultAddress',
};

export default addressMap;
